export { default } from "./FocusTrap.mjs";